import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import data from '../../data/cidr4.json';

const DeduplicationSummaryPieChart = () => {
    //4_deduplication_summary_pie


    if (!Array.isArray(data)) {
        return <div>Loading chart...</div>;
    }

    const total = data.reduce((sum, item) => sum + item.Count, 0);

    const option = {
        title: {
            text: ``,
            left: 'center',
            top: 'middle',
            textStyle: {
                fontSize: 16,
                fontWeight: 'bold',
                align: 'center',
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',

            },
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        },
        legend: {
            top: 'top',
            left: 'center',
            orient: 'horizontal',
            textStyle: {
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            },
        },
        series: [
            {
                name: 'Records',
                type: 'pie',
                radius: '60%',
                center: ['50%', '60%'],
                data: data.map(item => ({
                    name: item.Category,
                    value: item.Count,
                })),
                label: {
                    show: true,
                    position: 'inside',
                    formatter: '{b}: {d}%',
                },
                labelLine: {
                    show: true,
                },
                itemStyle: {
                    borderRadius: 6,
                    borderColor: '#fff',
                    borderWidth: 2,
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                },
            },
        ],
    };

    return (
        <div className="border-2 border-gray-300 rounded-lg p-4 shadow">
            <ReactECharts option={option} style={{ height: 500 }} />
        </div>
    );
};

export default DeduplicationSummaryPieChart;
